import { useCallback, useEffect, useState } from 'react'

import { RequestVisitorEmail } from '@liveHelper/components/RequestVisitorInformation/RequestVisitorEmail'
import { RequestVisitorFirstName } from '@liveHelper/components/RequestVisitorInformation/RequestVisitorFirstName'
import { useInitiateCall } from '@liveHelper/hooks/useInitiateCall'
import {
  actionsSelector,
  useStore,
  visitorInformationSelector,
} from '@liveHelper/models/store'

/**
 * RequestVisitorInformation component
 */
export const RequestVisitorInformation = () => {
  const { setVisitorInformation } = useStore(actionsSelector)

  const initiateCall = useInitiateCall({ shouldTrackClickStartCall: false })

  const [firstName, setFirstName] = useState('')

  const handleSubmitEmail = useCallback(
    (email) => {
      setVisitorInformation({ firstName, email })
    },
    [firstName, setVisitorInformation],
  )

  const visitorInformation = useStore(visitorInformationSelector)
  useEffect(() => {
    if (visitorInformation) {
      initiateCall?.()
    }
  }, [visitorInformation, initiateCall])

  if (!firstName) {
    return <RequestVisitorFirstName onSubmit={setFirstName} />
  } else {
    return <RequestVisitorEmail onSubmit={handleSubmitEmail} />
  }
}
